import { headerTrackings } from './header';
import { navigationTrackings } from './navigation';
import { navigationArmstrongTrackings } from './navigationArmstrong';
import { footerTrackings } from './footer';

const trackings = {
  ...headerTrackings,
  ...navigationTrackings,
  ...navigationArmstrongTrackings,
  ...footerTrackings,
};

export { trackings };
